module.exports = __webpack_public_path__ + "images/buttons/watch_overview_video-gray.gif";